import { FC, CSSProperties } from 'react';
import { Box, Divider, useTheme } from '@material-ui/core';

export interface WbDividerProps {
  orientation?: 'vertical' | 'horizontal';
  height?: string;
  className?: string;
  style?: CSSProperties;
}

export const WbDivider: FC<WbDividerProps> = ({
  orientation = 'vertical',
  height,
  className,
  style,
}) => {
  const theme = useTheme();
  return orientation === 'vertical' ? (
    <Box
      className={className}
      style={{
        background: theme.palette.grey[200],
        width: '1px',
        height: height ?? '24px',
        ...style,
      }}
    />
  ) : (
    <Divider className={className} style={style} />
  );
};
